import React, { Component } from 'react';
import OriginColorPicker from 'bee-colorpicker';
import { getMultiLang } from '@platform/api';

require('bee-colorpicker/build/ColorPicker.css');

export default class ColorPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            LangData: null,
        };
    }

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'containers_colorPicker', callback });
    }

    render() {
        let { json } = this.state;

        return (
            <OriginColorPicker
                title={json['001'] || '取色板'}
                confirmBtn={json['002'] || '确认'}
                cacelBtn={json['003'] || '取消'}
                {...this.props}
            />
        );
    }
}
